// <auto-generated />
// ATENCAO: Arquivo auto-gerado pelo SetupController. Nao altere manualmente.

export const FIN_ST_PLAN_CATEGFIN = {
  Rascunho: 'FIN_ST_PLAN_CATEGFIN1',
  Ativo: 'FIN_ST_PLAN_CATEGFIN2',
  Inativo: 'FIN_ST_PLAN_CATEGFIN3',
  // Mapa de sequencia (SequenciaLista) para lookup por codigo
  sequencia: {
    FIN_ST_PLAN_CATEGFIN1: 1,
    FIN_ST_PLAN_CATEGFIN2: 2,
    FIN_ST_PLAN_CATEGFIN3: 3
  }
}
